import {
  createQueryStringFromObject,
  getRequest,
  hasNextPage,
  PaginationOptions,
} from '../activity/helpers/utils';
import { PaginatedResults } from '../activity/types';

export const getRequestWithAllPages = async <T>(
  path: string,
  paginationOpts: PaginationOptions = {},
): Promise<T[]> => {
  const initialPath =
    path + createQueryStringFromObject(paginationOpts as never);
  const initialRequest = await getRequest<PaginatedResults<T>>(initialPath);
  // parallel pagination part
  if (hasNextPage(initialRequest)) {
    const limit = paginationOpts?.limit ?? initialRequest.pagination.limit;
    // take offset from first result
    const { offset: initialOffset, totalResults } = initialRequest.pagination;
    // calculate how many requests we need
    const numberOfRequests = Math.ceil(
      totalResults / initialRequest.results.length,
    );
    // create a promise per offset cutoff
    const rawRequests: Promise<PaginatedResults<T>>[] = [];
    for (let i = 1; i < numberOfRequests; i++) {
      const offset = initialOffset + i * limit;
      const newPaginationOpts = { limit, offset };
      const queryString = createQueryStringFromObject(
        newPaginationOpts as never,
      );
      const newPath = path + queryString;

      const newRequest = getRequest<PaginatedResults<T>>(newPath);

      rawRequests.push(newRequest);
    }

    const requests = await Promise.all(rawRequests);
    return [initialRequest, ...requests].flatMap((res) => res.results);
  }
  return initialRequest.results;
};
